/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShopPerformancePno } from './ShopPerformancePno';
import {
    ShopPerformancePnoFromJSON,
    ShopPerformancePnoFromJSONTyped,
    ShopPerformancePnoToJSON,
    ShopPerformancePnoToJSONTyped,
} from './ShopPerformancePno';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface PnoCompositionData
 */
export interface PnoCompositionData {
    /**
     * 
     * @type {ShopPerformancePno}
     * @memberof PnoCompositionData
     */
    total?: ShopPerformancePno;
    /**
     * 
     * @type {ShopPerformancePno}
     * @memberof PnoCompositionData
     */
    withoutOffline?: ShopPerformancePno;
    /**
     * 
     * @type {ShopPerformancePno}
     * @memberof PnoCompositionData
     */
    channelsOnly?: ShopPerformancePno;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof PnoCompositionData
     */
    snapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the PnoCompositionData interface.
 */
export function instanceOfPnoCompositionData(value: object): value is PnoCompositionData {
    return true;
}

export function PnoCompositionDataFromJSON(json: any): PnoCompositionData {
    return PnoCompositionDataFromJSONTyped(json, false);
}

export function PnoCompositionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PnoCompositionData {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : ShopPerformancePnoFromJSON(json['total']),
        'withoutOffline': json['withoutOffline'] == null ? undefined : ShopPerformancePnoFromJSON(json['withoutOffline']),
        'channelsOnly': json['channelsOnly'] == null ? undefined : ShopPerformancePnoFromJSON(json['channelsOnly']),
        'snapshot': json['snapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
    };
}

export function PnoCompositionDataToJSON(json: any): PnoCompositionData {
    return PnoCompositionDataToJSONTyped(json, false);
}

export function PnoCompositionDataToJSONTyped(value?: PnoCompositionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': ShopPerformancePnoToJSON(value['total']),
        'withoutOffline': ShopPerformancePnoToJSON(value['withoutOffline']),
        'channelsOnly': ShopPerformancePnoToJSON(value['channelsOnly']),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
    };
}

